import OnlineOnboardingContent from './online-onboarding-content';

export default OnlineOnboardingContent;
